<template>

  <div style="height:80%">
    <b-table :items="vehicles" :fields="fields" striped responsive="sm" @row-clicked="onRowClicked" class="row-pointer">
      <template #head()="data">
        <strong>{{data.label}}</strong>
      </template>
      <template #cell(vehicles)="row">
        <b-row>
          <b-col cols="6">
        <strong>Plate No. :</strong> {{ row.item.vehicle.plateNumber}}
        <b-badge variant="success" class="ml-5" v-if="defaultCar === row.item.vehicle._id">Default</b-badge>
          </b-col>
          <b-col cols="6">
               <strong>   Vin No. : </strong>{{row.item.vehicle.vinNumber}}
          </b-col>
         
        </b-row>
      </template>

      <template #row-details="row">
          <documentsList docType="vehicle"  
                  ref="documentList"         
                  :docList="getVehicleDocList(row.item.vehicle._id)"
                  :docErrors="errorDoc"
                  @saveDocCallback="saveDocument" 
                   @updateCallback="updateDocument"/>
      </template>
    </b-table>
        
  </div>
</template>

<script>
import shebahApi from "@/services/shebah/index";
import documentsList from "./docList";
export default {
  name: "vehicleDocumentsList",
  components: {
    documentsList
  },
  props: {
      driverId: String,
      defaultCar:String
  },
  computed: {},
  data() {
    return {
      vehicles: [],
      vehicleDocuments:{},
      selectedVehicleId:String,
      fields: ['vehicles'],
      errorDoc:{}
      
    };
  },
  watch: {},
  async created() {
      this.getdocuments();
  },
  methods: {
     async getdocuments(){
       
        this.vehicleDocuments=await shebahApi.api.drivers.documents.vehicleDocuments(this.driverId);
        this.vehicleDocuments.documents.forEach(doc => {
          this.vehicles.push({vehicle:doc.vehicle,_showDetails:false});
        });
     },
     async saveDocument(document){
       try{
          let savedDoc=await shebahApi.api.drivers.vehicles.saveVehicleDocuments(this.driverId,
              document.key,
              document.data,
              this.selectedVehicleId
            );
            this.errorDoc=null;
            await this.getdocuments();
            this.getVehicleDocList(this.selectedVehicleId);
            this.$emit("updatedCount", {_id:this.driverId,uploadCount:savedDoc.driverDocUploadCount});
       }catch(e){
         if (e.response) {
          if (
            typeof e.response.data.error !== "undefined" &&
            typeof e.response.data.error.collection !== "undefined"
          ) {
            this.errorDoc = e.response.data.error.collection;
          }
        }
       }
    },
    getVehicleDocList(vehicleId){
      var result=this.vehicleDocuments.documents.filter(doc=>{ return doc.vehicle._id==vehicleId});
      this.selectedVehicleId=vehicleId;
      return result[0];
    },
     onRowClicked (item, index, event) {
        item._showDetails = !item._showDetails;
    },
     async updateDocument(document){
       try{
      await shebahApi.api.drivers.vehicles.updateVehicleDocument(
              this.driverId,
              document.key,
              document.data,
              this.selectedVehicleId
            );
            this.errorDoc=null;
            this.getdocuments();
            this.getVehicleDocList(this.selectedVehicleId);
       }catch(e){
         if (e.response) {
          if (
            typeof e.response.data.error !== "undefined" &&
            typeof e.response.data.error.collection !== "undefined"
          ) {
            this.errorDoc = e.response.data.error.collection;
          }
        }
       }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
.row-pointer tr:hover td {
    background-color: #edf1f5;
    cursor: pointer;
}
.row-pointer tr.b-table-details:hover td{
  background-color: white !important;
  cursor:default;
}

</style>